import { SVGProps } from 'react';

const ArrowUpWideNarrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 8 7 4 3 8m4-4v16m4-8h10m-10 4h7m-7 4h4"
    />
  </svg>
);
export default ArrowUpWideNarrow;
